module.exports = __webpack_public_path__ + "static/media/ibopad2.24e38215.png";